import { render, staticRenderFns } from "./ReportKind.vue?vue&type=template&id=97c7f94a"
import script from "./report_kind.js?vue&type=script&lang=js&external"
export * from "./report_kind.js?vue&type=script&lang=js&external"
import style0 from "./ReportKind.vue?vue&type=style&index=0&id=97c7f94a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports